/**
 * Shared styles for the standalone auth pages (login, register, forgot, reset, accept invitation).
 */
export function authStyles(): string {
  return `
    .auth-container {
      min-height: 100vh;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, var(--gray-50) 0%, var(--gray-100) 100%);
      padding: var(--spacing-lg);
    }
    .auth-header { text-align: center; margin-bottom: var(--spacing-lg); }
    .auth-header h1 { font-size: 40px; font-weight: 800; color: var(--danger); margin-bottom: var(--spacing-sm); }
    .auth-header h1 a { color: inherit; text-decoration: none; }
    .subtitle { font-size: 16px; color: var(--gray-500); }
    .auth-card { background: white; border-radius: var(--border-radius); box-shadow: 0 4px 6px rgba(0,0,0,0.1); padding: 32px; width: 100%; max-width: 420px; }
    .auth-card h2 { font-size: 22px; font-weight: 600; color: var(--gray-900); margin-bottom: var(--spacing-md); text-align: center; }
    .auth-card p.help { color: var(--gray-500); font-size: 14px; margin-bottom: var(--spacing-md); text-align: center; }
    .error-message { background: #fef2f2; border: 1px solid #fecaca; color: #dc2626; padding: var(--spacing-md); border-radius: var(--border-radius); margin-bottom: var(--spacing-md); font-size: 14px; }
    .success-message { background: #ecfdf5; border: 1px solid #a7f3d0; color: #047857; padding: var(--spacing-md); border-radius: var(--border-radius); margin-bottom: var(--spacing-md); font-size: 14px; }
    .auth-form { display: flex; flex-direction: column; gap: var(--spacing-md); }
    .form-group { display: flex; flex-direction: column; gap: var(--spacing-sm); }
    label { font-size: 14px; font-weight: 500; color: var(--gray-700); }
    input { padding: 12px; border: 1px solid var(--gray-300); border-radius: var(--border-radius); font-size: 16px; transition: border-color 0.2s; }
    input:focus { outline: none; border-color: var(--primary); box-shadow: 0 0 0 3px rgba(59,130,246,0.1); }
    .btn-primary { padding: 12px; background: var(--primary); color: white; border: none; border-radius: var(--border-radius); font-size: 16px; font-weight: 500; cursor: pointer; transition: background 0.2s; }
    .btn-primary:hover:not(:disabled) { background: var(--primary-dark); }
    .btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }
    .auth-footer { margin-top: var(--spacing-lg); text-align: center; font-size: 14px; color: var(--gray-500); }
    .auth-footer a { color: var(--primary); text-decoration: none; }
    .auth-footer a:hover { text-decoration: underline; }
    .hint { font-size: 13px; color: var(--gray-500); }
  `;
}
